export const IS_HIDDEN = "_com.ducount.importer.isHidden";

export const IS_DUPLICATE = "_com.ducount.importer.isDuplicate";
